import React, { lazy, Suspense, useEffect } from "react";
import { paths } from "../config/constants";
import { Route, Routes, useLocation } from "react-router-dom";
import Error from "../pages/Error";
import AppLayout from "../component/layout/AppLayout";
import { PageLoading } from "../component/includes/PageLoading";
import DriverEmployeeLayout from "../component/layout/DriverEmployeeLayout";
import DriverCarrierLayout from "../pages/DriverCarrier/DriverCarrierLayout";
import UserLayout from "../pages/UserLayout";
import Bussinesslayout from "../component/layout/Bussinesslayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyStaff from "../pages/BussinessAgent/myStaff";
import CompanyLayout from "../pages/BussinessAgent/companyLayout";
import Dashboard from "../pages/BussinessAgent/dashboard";
import EditBussinessBooking from "../pages/BussinessAgent/editBussinessBooking";
import CompanyAgentCommonReport from "../pages/BussinessAgent/CompanyAgentCommonReports";
import ProtectedRoute from "./ProtectedRoute";
import { ROLES } from "../config/roles";
// import { resetContact } from "../redux/reducers/contactReducer";
// import { resetHomeRe } from "../redux/reducers/homeReducer";
// import { reset } from "../redux/reducers/login";

//Common
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const Qans = lazy(() => import("../pages/Qans"));
const SocialLogin = lazy(() => import("../pages/SocialLogin"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const BussinessAccount = lazy(() => import("../pages/BussinessAccount"));
const BookingTermsAndCond = lazy(() => import("../pages/BookingTermsAndCond"));
const CancellationPolicy = lazy(() => import("../pages/CancellationPolicy"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const Services = lazy(()=>import("../services/Services"))
const CityToCityRides = lazy(()=>import("../services/CityToCityRides"))
const VipService = lazy(()=>import("../services/VipService"))
const BusinessTransfer = lazy(()=>import("../services/BusinessTransfer"))
const PrivateCarService = lazy(()=>import("../services/PrivateCarService"))
const AirportTransfer = lazy(()=>import("../services/AirportTransfer"))
const BaggageTransfer = lazy(()=>import("../services/BaggageTransfer"))
const PetTransfer = lazy(()=>import("../services/PetTransfer"))
const TourAndEventTransfer =lazy(()=> import("../services/EventAndTourTransfer"))
const PatientTransfer = lazy(()=> import("../services/PatientTransfer"))

const TermsAndCondition = lazy(() => import("../pages/TermsAndCondition"));
const EmployeeTermsAndCondition = lazy(() => import("../pages/BussinessAgent/EmployeeTermsAndConditions"));
const CompanyAgentCancellationPolicy = lazy(() => import("../pages/CancellationPolicy"));
const CompanyTermsAndCondition = lazy(() => import("../pages/BussinessAgent/CompanyTermsAndConditions"));
const AgentTermsAndCondition = lazy(() => import("../pages/BussinessAgent/AgentTermsAndConditions"));
const Done = lazy(() => import("../pages/Done"));
const Summary = lazy(() => import("../pages/Summary"));
const ContactInfo = lazy(() => import("../pages/ContactInfo"));
const VehicleOption = lazy(() => import("../pages/VehicleOption"));
const EditProfile = lazy(() => import("../pages/EditProfile"));
const MyRide = lazy(() => import("../pages/MyRide"));
const Home = lazy(() => import("../pages/Home"));

//Bussiness Agent
const BusinesHome = lazy(() => import("../pages/BussinessAgent/Home"));
const BusinesVehicleoption = lazy(() =>
  import("../pages/BussinessAgent/VehivleOption")
);
const BusinesContact = lazy(() => import("../pages/BussinessAgent/Contact"));
const BusinesSummary = lazy(() => import("../pages/BussinessAgent/Summery"));
const BusinesDone = lazy(() => import("../pages/BussinessAgent/Done"));
const BusinessRides = lazy(() =>
  import("../pages/BussinessAgent/BusinessRides")
);
const BusinessRegisterStaff = lazy(() =>
  import("../pages/BussinessAgent/StaffRegister")
);
const EditStaff = lazy(() =>
  import("../pages/BussinessAgent/EditStaff")
);
const BussinessBooking = lazy(() =>
  import("../pages/BussinessAgent/bussinessBooking")
);
const BankInvoiceHistory = lazy(()=>
  import("../pages/BussinessAgent/BankInvoiceHistory")
)
const CommissionInvoiceHistory = lazy(()=>
  import("../pages/BussinessAgent/commissionInvoiceHistory")
)
//driver
const DriverTermsConditons = lazy(() =>
  import("../pages/driver/DriverTermsAndCondition")
);
const RideReport = lazy(() => import("../pages/driver/RideReport"));
const UserEmployeeRideReport = lazy(() => import("../pages/UserEmployeeRideReport"));
const RideHistory = lazy(() => import("../pages/driver/RideHistory"));
const DriverDashboard = lazy(() => import("../pages/driver/DriverDashboard"));
const UpcomingRides = lazy(() => import("../pages/driver/UpcomingRides"));
const DriverCarrierDashboard = lazy(() => import("../pages/DriverCarrier/DriverCarrierDashboard"));
const DriverCarrierOpenBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierOpenBooking"));
const DriverCarrierMyBookings = lazy(() => import("../pages/DriverCarrier/DriverCarrierMyBookings"));
const DriverCarrierAssignDriverVehicle = lazy(() => import("../pages/DriverCarrier/DriverCarrierAssignDriverVehicle"));
const DriverCarrierUpcomingBookings = lazy(() => import("../pages/DriverCarrier/DriverCarrierUpcomingBookings"));
const DriverCarrierEditProfile = lazy(() => import("../pages/DriverCarrier/DriverCarrierEditProfile"));
const DriverCarrierCreateBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierCreateBooking"));
const DriverCarrierEditBooking = lazy(() => import("../pages/DriverCarrier/DriverCarrierEditBooking"));
const AddEditDriver = lazy(() =>  import("../pages/DriverCarrier/AddEditDriver"));
const DriversList = lazy(() => import("../pages/DriverCarrier/DriversList"));
const DriverCarrierVehicles = lazy(() => import("../pages/DriverCarrier/DriverCarrierVehicles"));
const CommonReports = lazy(()=>import("../pages/DriverCarrier/CommonReports"))
const CarrierRideHistory = lazy(()=>import("../pages/DriverCarrier/CarrierRideHistory"))
const CarrierInvoiceHistory = lazy(()=>import("../pages/DriverCarrier/CarrierInvoiceHistory"))
const CarrierTermsAndConditions = lazy(()=>import("../pages/DriverCarrier/CarrierTermsAndConditions"))
const CarrierCancellationPolicy = lazy(()=>import("../pages/DriverCarrier/CarrierCancellationPolicy"))
const AirportTemplate = lazy(() => import("../pages/AirportTemplate"));

//auth
const ForgetPassword = lazy(() => import("../pages/auth/ForgetPassword"));
const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));
const LogIn = lazy(() => import("../pages/auth/Login"));
const DriverRegistration = lazy(() =>
  import("../pages/auth/DriverRegistration")
);
const AgentRegistration = lazy(() =>
  import("../pages/auth/AgentRegistration")
);
const PartnerRegister = lazy(() => import("../pages/auth/PartnerRegister"));
const DriverCarrierRegistration = lazy(() =>
  import("../pages/auth/DriverCarrierRegistration")
);

function RouteApp() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);



  return (
    <>
      <Routes>
        {/* auth page */}
        <Route path={paths.accounts.home} element={<AppLayout />}>
          <Route
           path="forget-password/:token"
            element={
              <Suspense fallback={<PageLoading />}>
                <ForgetPassword />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.driverRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.agentRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <AgentRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.partnerRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <PartnerRegister />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.driverCarrierRegister}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierRegistration />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.login}
            element={
              <Suspense fallback={<PageLoading />}>
                <LogIn />
              </Suspense>
            }
          />
          <Route
            path={paths.accounts.socialLogin}
            element={
              <Suspense fallback={<PageLoading />}>
                <SocialLogin />
              </Suspense>
            }
          />
        </Route>

        
        
        
        {/* businessAgent */}
<Route element={<ProtectedRoute allowedRoles={["Agent"]} />}>
        <Route path={paths.businessAgent.home} element={<CompanyLayout />}>
          <Route
              path={paths.businessAgent.dashboard}
              element={
                <Suspense fallback={<PageLoading />}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
            path={paths.businessAgent.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
           <Route
            path={paths.businessAgent.BussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.AgentBankInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <BankInvoiceHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.AgentCommissionInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CommissionInvoiceHistory />
              </Suspense>
            }
          />

<Route
  path={paths.businessAgent.ReportsPage}
  element={<Suspense fallback={<PageLoading />}>
                <CompanyAgentCommonReport type="agent"/>
              </Suspense>}
/>

          <Route
            path={paths.businessAgent.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.editBussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditBussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgent.termsAndCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <AgentTermsAndCondition/>
              </Suspense>
            }
          />

        </Route>
        </Route>
        
        {/* Company */}
        <Route element={<ProtectedRoute allowedRoles={["Company"]} />}>
        <Route path={paths.company.home} element={<CompanyLayout />}>
            <Route
              path={paths.company.dashboard}
              element={
                <Suspense fallback={<PageLoading />}>
                  <Dashboard />
                </Suspense>
              }
            />
             <Route
            path={paths.company.myStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <MyStaff />
              </Suspense>
            }
          />
        <Route
            path={paths.company.CompanyBankInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <BankInvoiceHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.company.CompanyCommissionInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CommissionInvoiceHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.company.editBussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditBussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.company.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
           <Route
            path={paths.company.companyRegisterStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <BusinessRegisterStaff />
              </Suspense>
            }
          /> 
          <Route
            path={paths.company.EditStaff}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditStaff />
              </Suspense>
            }
          />
          <Route
            path={paths.company.BussinessBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessBooking />
              </Suspense>
            }
          />
          <Route
            path={paths.company.changePassword}
            element={
              <Suspense fallback={<PageLoading />}>
                <ChangePassword />
              </Suspense>
            }
          />

          <Route
            path={paths.company.termsAndCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <CompanyTermsAndCondition />
              </Suspense>
            }
          />

          <Route
        path={paths.company.cancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CompanyAgentCancellationPolicy />
              </Suspense>
            }
          />

<Route
  path={paths.company.companyReport}
  element={
    <Suspense fallback={<PageLoading />}>
      <CompanyAgentCommonReport type="company" />
    </Suspense>
  }
/>

<Route
  path={paths.company.customerReport}
  element={<Suspense fallback={<PageLoading />}>
    <CompanyAgentCommonReport type="customer" />
  </Suspense>}
/>

<Route
  path={paths.company.employeeReport}
  element={<Suspense fallback={<PageLoading />}>
  <CompanyAgentCommonReport type="employee" />
    </Suspense>  }
/>

            
           {/* <Route
              path={paths.admin.changePassword}
              element={
                <Suspense fallback={<PageLoading />}>
                  <ChangePassword />
                </Suspense>
              }
            /> */}
          </Route>
</Route>
        
<Route element={<ProtectedRoute allowedRoles={["Driver","Employee"]} />}>
  <Route path="/" element={<DriverEmployeeLayout />}>
    {/* Employee routes */}
    <Route path={paths.employeeBooking} element={<BussinessBooking />} />
   <Route
      path={paths.employeeUpcomingRides}
      element={<BusinessRides rideType="upcoming" />}
    />

    <Route
      path={paths.employeeRideHistory}
      element={<BusinessRides rideType="history" />}
    />

        <Route path={paths.employeeRideReport} element={<Suspense fallback={<PageLoading />}>
                <UserEmployeeRideReport />
              </Suspense>} />

     <Route
            path={paths.employeeTermsAndCondition}
            element={
              <Suspense fallback={<PageLoading />}>
                <EmployeeTermsAndCondition />
              </Suspense>
            }
          />

          <Route
        path={paths.cancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CompanyAgentCancellationPolicy />
              </Suspense>
            }
          />

    {/* Driver routes */}
  
    <Route path={paths.driver.dashboard} element={<DriverDashboard />} />
    <Route path={paths.driver.upcomingRides} element={<UpcomingRides />} />
    <Route path={paths.driver.rideReport} element={<RideReport />} />
    <Route path={paths.driver.rideHistory} element={<RideHistory />} />
    <Route path={paths.driver.driverTermsCondition} element={<DriverTermsConditons />} />
  </Route>
</Route>


{/* driver carrier page */}
<Route element={<ProtectedRoute allowedRoles={["Carrier"]} />}>
        <Route path={paths.driverCarrier.home} element={<DriverCarrierLayout />}>
                   <Route
            path={paths.driverCarrier.dashboard}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierDashboard />
              </Suspense>
            }
          />
             <Route
            path={paths.driverCarrier.openBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierOpenBooking />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.myBookings}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierMyBookings />
              </Suspense>
            }
          />
           <Route
            path={paths.driverCarrier.assignDriverVehicle}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierAssignDriverVehicle />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.upcomingBookings}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierUpcomingBookings />
              </Suspense>
            }
          />
                    <Route
            path={paths.driverCarrier.createBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierCreateBooking />
              </Suspense>
            }
          />
         <Route
            path={paths.driverCarrier.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierEditProfile />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.editBooking}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierEditBooking />
              </Suspense>
            }
          />
           <Route
                    path={paths.driverCarrier.driverForm} 
                    element={
                        <Suspense fallback={<PageLoading />}>
                            <AddEditDriver />
                        </Suspense>
                    }
                />
          <Route
            path={paths.driverCarrier.driverList}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriversList />
              </Suspense>
            }
          /> 
           <Route
            path={paths.driverCarrier.vehicles}
            element={
              <Suspense fallback={<PageLoading />}>
                <DriverCarrierVehicles />
              </Suspense>
            }
          />
         <Route
  path={paths.driverCarrier.CarrierMyBookingsReports}
  element={
    <Suspense fallback={<PageLoading />}>
      <CommonReports />
    </Suspense>
  }
/>

<Route
  path={paths.driverCarrier.driverReport}
  element={
    <Suspense fallback={<PageLoading />}>
      <CommonReports />
    </Suspense>
  }
/>

<Route
  path={paths.driverCarrier.vehicleReport}
  element={
    <Suspense fallback={<PageLoading />}>
      <CommonReports />
    </Suspense>
  }
/>
          <Route
            path={paths.driverCarrier.carrierRideHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierRideHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.carrierInvoiceHistory}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierInvoiceHistory />
              </Suspense>
            }
          />
          <Route
            path={paths.driverCarrier.carrierTermsAndConditions}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierTermsAndConditions />
              </Suspense>
            }
          />
                   <Route
            path={paths.driverCarrier.carrierCancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierCancellationPolicy />
              </Suspense>
            }
          />

        </Route>
        </Route>

                  <Route element={<ProtectedRoute allowedRoles={["User"]} />}>
           <Route path={paths.userHome} element={<UserLayout />}>
          <Route
            path={paths.user.editProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />

          <Route
            path={paths.user.dashboard}
            element={
              <Suspense fallback={<PageLoading />}>
                <MyRide />
              </Suspense>
            }
          />

  <Route path={paths.user.rideReport} element={<Suspense fallback={<PageLoading />}>
                <UserEmployeeRideReport />
              </Suspense>} />

             <Route
      path={paths.user.bookingTermsAndCond}
      element={
        <Suspense fallback={<PageLoading />}>
          <BookingTermsAndCond />
        </Suspense>
      }
    />
    <Route
      path={paths.user.cancellationPolicy}
      element={
        <Suspense fallback={<PageLoading />}>
          <CancellationPolicy />
        </Suspense>
      }
    />
          </Route>
        
              </Route>






        {/* common pages */}
        <Route path={paths.home} element={<AppLayout />}>
          <Route
            index
            element={
              <Suspense fallback={<PageLoading />}>
                <Home />
              </Suspense>
            }
          />
          <Route
            path={paths.vehicle}
            element={
              <Suspense fallback={<PageLoading />}>
                <VehicleOption />
              </Suspense>
            }
          />
           <Route
            path={paths.carrierTermsAndConditions2}
            element={
              <Suspense fallback={<PageLoading />}>
                <CarrierTermsAndConditions />
              </Suspense>
            }
          />
          <Route
            path={paths.businessAgentTermsAndCondition2}
            element={
              <Suspense fallback={<PageLoading />}>
                <AgentTermsAndCondition />
              </Suspense>
            }
          />
           <Route
            path={paths.companyTermsAndCondition2}
            element={
              <Suspense fallback={<PageLoading />}>
                <CompanyTermsAndCondition />
              </Suspense>
            }
          />
         
          <Route
            path={paths.contact}
            element={
              <Suspense fallback={<PageLoading />}>
                <ContactInfo />
              </Suspense>
            }
          />
          <Route
            path={paths.summary}
            element={
              <Suspense fallback={<PageLoading />}>
                <Summary />
              </Suspense>
            }
          />
          <Route
            path={paths.done}
            element={
              <Suspense fallback={<PageLoading />}>
                <Done />
              </Suspense>
            }
          />          

                    <Route
            path={paths.agentProfile}
            element={
              <Suspense fallback={<PageLoading />}>
                <EditProfile />
              </Suspense>
            }
          />
          <Route
            path={paths.aboutUs}
            element={
              <Suspense fallback={<PageLoading />}>
                <AboutUs />
              </Suspense>
            }
          /> 
          <Route
            path={paths.services}
            element={
              <Suspense fallback={<PageLoading />}>
                <Services/>
              </Suspense>
            }
          />
          <Route
            path={paths.cityToCityRides}
            element={
              <Suspense fallback={<PageLoading />}>
                <CityToCityRides/>
              </Suspense>
            }
          />
          <Route
            path={paths.vipService}
            element={
              <Suspense fallback={<PageLoading />}>
                <VipService/>
              </Suspense>
            }
          />
          <Route
            path={paths.businessTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <BusinessTransfer/>
              </Suspense>
            }
          />
          <Route
            path={paths.privateCarService}
            element={
              <Suspense fallback={<PageLoading />}>
                <PrivateCarService/>
              </Suspense>
            }
          />
          <Route
            path={paths.airportTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <AirportTransfer/>
              </Suspense>
            }
          />     
          <Route
            path={paths.baggageTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <BaggageTransfer/>
              </Suspense>
            }
          />   
          <Route
            path={paths.tourAndEventTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <TourAndEventTransfer/>
              </Suspense>
            }
          />
          <Route
            path={paths.patientTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <PatientTransfer/>
              </Suspense>
            }
          />
          <Route
            path={paths.petTransfer}
            element={
              <Suspense fallback={<PageLoading />}>
                <PetTransfer/>
              </Suspense>
            }
          />
          <Route
            path={paths.bookingTermsAndCond2}
            element={
              <Suspense fallback={<PageLoading />}>
                <BookingTermsAndCond />
              </Suspense>
            }
          />
           <Route
            path={paths.cancellationPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <CancellationPolicy />
              </Suspense>
            }
          />
          <Route
            path={paths.bussinessAccount}
            element={
              <Suspense fallback={<PageLoading />}>
                <BussinessAccount />
              </Suspense>
            }
          />
          <Route
            path={paths.contactUs}
            element={
              <Suspense fallback={<PageLoading />}>
                <ContactUs />
              </Suspense>
            }
          />
        
           <Route
            path={paths.privacyPolicy}
            element={
              <Suspense fallback={<PageLoading />}>
                <PrivacyPolicy />
              </Suspense>
            }
          />
            <Route
            path={paths.qans}
            element={
              <Suspense fallback={<PageLoading />}>
                <Qans />
              </Suspense>
            }
          /> 
          <Route
            path={paths.AirportTemplate}
            element={
              <Suspense fallback={<PageLoading />}>
                <AirportTemplate />
              </Suspense>
            }
          />
              
        </Route>

        <Route
          path={"*"}
          element={
            <Suspense fallback={<PageLoading />}>
              <Error />
            </Suspense>
          }
        />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default RouteApp;
